import CSS from 'csstype';

export const subTitle: CSS.Properties = {
    fontFamily: "monospace",
    fontSize: "1.4rem",
    padding: "0.5rem 0 0.5rem 0",
    fontWeight: "bold",
};

export const largeTitle: CSS.Properties = {
    fontFamily: "monospace",
    fontSize: "2rem",
    fontWeight: "bold",
};

export const textMedium: CSS.Properties = {
    fontFamily: "monospace",
    fontSize: "2rem",
};

export const textSmall: CSS.Properties = {
    fontFamily: "monospace",
    fontSize: "1.2rem",
    width: "100%",
};